import { normalize } from 'normalizr';
import { cityApi, cuisineApi, eateryApi, tagApi, storyApi, fileApi } from 'api';
import { citySchema, cuisineSchema, tagSchema } from 'schemas';
import { operations as entitiesOps } from 'schemas/duck';
import actions from './actions';

const fetchStoryByTitle = slug => dispatch =>
  storyApi
    .getBySlug(slug)
    .then(({ data: { data } }) => {
      dispatch(actions.setStory(data));
    });

const fetchCities = () => dispatch =>
  cityApi.get().then(({ data }) => {
    const { entities } = normalize(data, [citySchema]);
    dispatch(entitiesOps.mergeEntities(entities));
  });

const fetchCuisines = () => dispatch =>
  cuisineApi.get().then(({ data }) => {
    const { entities } = normalize(data, [cuisineSchema]);
    dispatch(entitiesOps.mergeEntities(entities));
  });

const fetchEateries = () => dispatch =>
  eateryApi
    .get({
      limit: 2000,
      fields:
        'content[id],content[name],content[location[fullAddress]],content[city[id]]',
    })
    .then(({ data: { content } }) =>
      dispatch(
        actions.setEateries(
          content
            .map(e => ({
              value: e.id.toString(),
              label: e.name,
              city: (e.city || { id: 0 }).id.toString(),
            }))
            .sort(({ label: l1 }, { label: l2 }) => l1.localeCompare(l2))
        )
      )
    );

const fetchTags = () => dispatch =>
  tagApi.get().then(({ data }) => {
    const { entities } = normalize(data, [tagSchema]);
    dispatch(entitiesOps.mergeEntities(entities));
  });

const upsertStory = (story) => dispatch => {
  let storyMainImage = !!story.mainImage.file ? [story.mainImage] : [];
  const images = storyMainImage.filter(({ file }) => !!file);
  dispatch(actions.setIsSaving(true));

  (images.length
    ? fileApi.postMultiple(images.map(({ file }) => file)).then(({ data }) =>
      data.forEach(({ fileDownloadUri }, index) => {
        images[index].uri = fileDownloadUri;
        delete images[index].file;
      })
    )
    : Promise.resolve()
  )
    .then(() => {
      story.id ? storyApi.put(story) : storyApi.post(story);
    }
    )
    .then(() => {
      dispatch(actions.setEditedSlug(story));
      dispatch(actions.setIsSaving(false));
    })
    .catch(() => { })
};

export default {
  fetchCities,
  fetchCuisines,
  fetchEateries,
  fetchTags,
  fetchStoryByTitle,
  upsertStory
};
